import { render } from "./ImplantsPain.vue?vue&type=template&id=52849139"
import script from "./ImplantsPain.vue?vue&type=script&lang=js"
export * from "./ImplantsPain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__